// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-AutoDocExtraction-OutstandingSuggestionsModal-SuggestionExample-module__accept";
var _2 = "webpack-concepts-AutoDocExtraction-OutstandingSuggestionsModal-SuggestionExample-module__action";
var _3 = "webpack-concepts-AutoDocExtraction-OutstandingSuggestionsModal-SuggestionExample-module__example";
var _4 = "webpack-concepts-AutoDocExtraction-OutstandingSuggestionsModal-SuggestionExample-module__frame";
var _5 = "webpack-concepts-AutoDocExtraction-OutstandingSuggestionsModal-SuggestionExample-module__reject";
export { _1 as "accept", _2 as "action", _3 as "example", _4 as "frame", _5 as "reject" }
